<template>
  <v-container fill-height>
    <v-layout>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-icon
              medium
              left>
              email
            </v-icon>
            <span class="title"><b>{{ this.kodesurat }}</b></span>
            <v-spacer></v-spacer>
            <v-btn
              :to="{ name: 'SuratKlian' }"
              color="error"
              icon
              x-small>
              <v-icon>arrow_back</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-container>
              <alertsp :alertdata="alertgetdata"></alertsp>
              <div class="text-center" v-if="loading.getdata">
                <v-progress-circular
                  :width="3"
                  color="red"
                  indeterminate>
                </v-progress-circular>
              </div>
              <v-row justify="center" v-if="detaildata">
                <v-col cols="12" md="8" class="px-md-10 border-solid-thin text-justify">
                  <v-row justify="center" align="center">
                    <v-col cols="12" md="2" class="text-center">
                      <img class="mr-3" :src="require('../../assets/' + prefix + '/logo.png')" height="100"/>
                    </v-col>
                    <v-col cols="12" md="10" class="text-center">
                      <div class="headline text-uppercase">PEMERINTAH KABUPATEN {{ staticdata.kabupaten }}</div>
                      <div class="headline text-uppercase">KECAMATAN {{ staticdata.kecamatan }}</div>
                      <div class="headline text-uppercase">DESA {{ staticdata.desa }}</div>
                      <div class="subtitle-1 text-uppercase">KELIAN BANJAR DINAS {{ userbanjarname }}</div>
                    </v-col>
                  </v-row>
                  <v-divider></v-divider>
                  <v-row justify="center" align="center">
                    <v-col cols="12">
                      <div class="text-center text-underline title">SURAT PENGANTAR</div>
                      <div class="text-center">Nomor: {{ detaildata.no_pengantar ? detaildata.no_pengantar : '_______/_______/_______' }}</div>
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col cols="12">
                      <p>Yang bertanda tangan dibawah ini Klian Banjar Dinas {{ userbanjarname }}, Desa {{ staticdata.desa }}, Kecamatan {{ staticdata.kecamatan }}, Kabupaten {{ staticdata.kabupaten }}, menerangkan bahwa:</p>
                      <table class="ml-5 tbl-align-top">
                        <tr>
                          <td class="min-first-colm">Nama</td>
                          <td>:</td>
                          <td><b>{{ detaildata.nama }}</b></td>
                        </tr>
                        <tr>
                          <td>Tempat / Tanggal Lahir</td>
                          <td>:</td>
                          <td><b>{{ detaildata.tempat_lahir }} / {{ detaildata.tanggal_lahir }}</b></td>
                        </tr>
                        <tr>
                          <td>Jenis Kelamin</td>
                          <td>:</td>
                          <td><b>{{ detaildata.kelamin | kelaminParse }}</b></td>
                        </tr>
                        <tr>
                          <td>Agama</td>
                          <td>:</td>
                          <td><b>{{ detaildata.agama }}</b></td>
                        </tr>
                        <tr>
                          <td>Pekerjaan</td>
                          <td>:</td>
                          <td><b>{{ detaildata.pekerjaan }}</b></td>
                        </tr>
                        <tr>
                          <td>Nomor NIK</td>
                          <td>:</td>
                          <td><b>{{ detaildata.nik }}</b></td>
                        </tr>
                        <tr>
                          <td>Alamat</td>
                          <td>:</td>
                          <td><b>{{ detaildata.alamat }}, Desa {{ staticdata.desa }}, Kecamatan {{ staticdata.kecamatan }}, Kabupaten {{ staticdata.kabupaten }}.</b></td>
                        </tr>
                        <tr>
                          <td>Keterangan</td>
                          <td>:</td>
                          <td>Sepengetahuan kami bahwa, <b>{{ updatesurat.deskripsi_surat }}</b></td>
                        </tr>
                      </table>
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col cols="12">
                      <p>Surat Pengantar ini dipergunakan untuk melengkapi administrasi <b>{{ detaildata.nama_js }}</b></p>
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col cols="12">
                      <p>Demikian surat keterangan ini kami buat dengan sebenarnya untuk dapat dipergunakan sebagaimana mestinya.</p>
                    </v-col>
                  </v-row>
                  <v-row justify="end">
                    <v-col cols="12" md="4" class="text-center">
                      <div>{{ staticdata.desa }}, {{ new Date() | dateToIndo }}</div>
                      <div>{{ detaildata.ttd_b_surat ? detaildata.ttd_b_surat : 'Kelian Banjar Dinas ' + userbanjarname }}</div>
                      <br/>
                      <br/>
                      <br/>
                      <div>( {{ detaildata.ttd_b_surat ? detaildata.ttd_b_surat : this.username }} )</div>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="4" class="pl-md-10 pt-md-0">
                  <div class="text-right">
                    <v-chip
                      v-if="!canchange"
                      color="red"
                      fab
                      text-color="white">
                      <v-icon left>bookmark</v-icon>
                      {{ updatesurat.status_surat }}
                    </v-chip>
                  </div>
                  <v-form
                    ref="formupdatesurat"
                    v-model="formadd.valid"
                    lazy-validation>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          :disabled="true"
                          :readonly="true"
                          :value="detaildata.nama_js"
                          label="Jenis Surat"
                          name="jenis_surat">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          :disabled="true"
                          :readonly="true"
                          :value="detaildata.nama"
                          label="Nama Pemohon"
                          name="nama">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-textarea
                          :disabled="!canchange"
                          v-model="updatesurat.deskripsi_surat"
                          auto-grow
                          label="Deskripsi Surat"
                          :rules="[rules.required]"
                          rows="1">
                        </v-textarea>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <alertsp :alertdata="alertdata"></alertsp>
                        <div class="text-center" v-if="loading.update">
                          <v-progress-circular
                            :width="3"
                            color="red"
                            indeterminate>
                          </v-progress-circular>
                        </div>
                        <v-btn
                          v-if="!loading.update && !isapproved && canchange"
                          large
                          block
                          :disabled="!formadd.valid"
                          color="success"
                          class="mr-4 mt-5"
                          @click="submitUpdate('accbanjar')">
                          Simpan
                        </v-btn>
                        <v-btn
                          v-if="!loading.update && !isapproved && canchange"
                          large
                          block
                          :disabled="!formadd.valid"
                          color="error"
                          class="mr-4 mt-5"
                          @click="submitUpdate('permohonan')">
                          Simpan & Approve
                        </v-btn>
                        <v-btn
                          v-if="!loading.update && !isapproved && canchange"
                          large
                          block
                          dark
                          color="grey darken-4"
                          class="mr-4 mt-5"
                          @click="submitUpdate('batal')">
                          Tolak
                        </v-btn>
                        <v-btn
                          v-if="!canchange"
                          large
                          block
                          outlined
                          color="primary"
                          class="mr-4 mt-5"
                          :to="{ name: 'SuratKlian' }">
                          Kembali
                        </v-btn>
                        <v-btn
                          v-if="isapproved"
                          large
                          block
                          color="primary"
                          class="mr-4 mt-5"
                          :to="{ name: 'SuratKlian' }">
                          Selesai
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { getDateTodayId } from '../../utils/dateFormatCustom.js';
import { mapState } from 'vuex';

export default {
  name: 'SuratDetailKlian',
  props: ['kodesurat'],
  data: () => ({
    alertgetdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      getdata: false,
      update: false,
    },
    prefix: process.env.VUE_APP_PREFIX,
    api: process.env.VUE_APP_API,
    modulklian: process.env.VUE_APP_MOD_KLIAN,
    liststatus: ['permohonan', 'proses', 'siap', 'selesai', 'batal'],
    detaildata: null,
    updatesurat: {
      deskripsi_surat: '',
      status_surat: '',
      kode_surat: '',
      no_surat: '',
    },
    formadd: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (v) && v.length >= 6 || 'Min 6 characters',
      nik: (v) => (v) && v.length >= 16 || 'Min 16 characters',
    },
    urlprint: '',
    isapproved: false,
    canchange: true,
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
      'usernik',
      'userbanjar',
      'username',
      'userbanjarname',
      'staticdata',
    ]),
  },
  mounted() {
    if (this.kodesurat) {
      this.getDetailSurat();
    }
  },
  filters: {
    dateToAge(value) {
      return value;
    },
    dateToIndo(value) {
      return getDateTodayId(value);
    },
    kelaminParse(value) {
      return value === 'L' ? 'Laki-Laki' : 'Perempuan';
    },
  },
  methods: {
    checkCanChange() {
      this.canchange = true;
      const denystatus = ['batal', 'selesai', 'siap'];
      if (denystatus.indexOf(this.updatesurat.status_surat) >= 0) {
        this.canchange = false;
      }
    },
    getDetailSurat() {
      if (this.tokenscr) {
        this.loading.getdata = true;
        this.axios
          .get(
            this.api + '/api/surat/' + this.kodesurat,
            {
              params: {
                banjar: this.userbanjar,
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                if (resdata.data.length > 0) {
                  this.detaildata = resdata.data[0];
                  this.updatesurat.kode_surat = resdata.data[0].kode_surat;
                  this.updatesurat.deskripsi_surat = resdata.data[0].deskripsi_surat;
                  this.updatesurat.status_surat = resdata.data[0].status_surat;
                  this.urlprint = this.api + '/public/surat/' + this.kodesurat + '/' + resdata.data[0].nik_surat;
                  this.checkCanChange();
                } else {
                  this.alertgetdata.show = true;
                  this.alertgetdata.type = 'error';
                  this.alertgetdata.text = 'Data tidak ditemukan!';
                }
              } else {
                this.alertgetdata.show = true;
                this.alertgetdata.type = 'error';
                this.alertgetdata.text = resdata.message;
              }
            } else {
              this.alertgetdata.show = true;
              this.alertgetdata.type = 'error';
              this.alertgetdata.text = 'Internal services error!';
            }
            this.loading.getdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.alertgetdata.show = true;
            this.alertgetdata.type = 'error';
            this.alertgetdata.text = 'Internal services error!';
            this.loading.getdata = false;
          });
      }
    },
    submitUpdate(status) {
      this.alertdata.show = false;
      if (this.$refs.formupdatesurat.validate()) {
        if (this.tokenscr) {
          this.loading.update = true;
          this.isapproved = false;
          // status
          this.updatesurat.status_surat = status;
          this.axios
            .put(
              this.api + '/api/surat/',
              qs.stringify(
                this.updatesurat,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.alertdata.show = true;
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'Permohonan surat "' + this.updatesurat.kode_surat + '" berhasil diperbaharui!';
                  if (status === 'permohonan') {
                    this.isapproved = true;
                    this.alertdata.text = 'Permohonan surat "' + this.updatesurat.kode_surat + '" berhasil disetujui!';
                  }
                  if (status === 'batal') {
                    this.isapproved = true;
                    this.alertdata.text = 'Permohonan surat "' + this.updatesurat.kode_surat + '" berhasil ditolak!';
                  }
                  this.$root.$emit('app-getnotifiaction');
                  // this.getDetailSurat();
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = resdata.message;
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = 'Internal services error!';
              }
              this.loading.update = false;
            })
            .catch((error) => {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
              this.loading.update = false;
            });
        } else {
          this.alertdata.show = true;
          this.alertdata.type = 'error';
          this.alertdata.text = 'Invalid token!';
        }
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .text-underline{
    text-decoration: underline;
  }
  .border-solid-thin{
    border: solid thin #f1f1f1;
  }
</style>
